import { cn } from "@/lib/utils";

const BTN = {
  primary: "bg-[#E5B85C] hover:bg-[#f0c96f] text-[#17211D] shadow-[0_14px_28px_rgba(23,33,29,0.16)]",
  secondary: "bg-[#FFFAF1]/90 border border-[#17211D]/10 text-[#17211D] hover:bg-white shadow-sm",
  destructive: "bg-[#B96F48] hover:bg-[#a65f3e] text-white shadow-sm",
  ghost: "text-[#254F43] hover:bg-[#E5B85C]/20",
};

export function Btn({ variant = "primary", className, children, ...props }) {
  return (
    <button
      className={cn(
        "inline-flex min-h-10 items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-all duration-150 active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2D7A65] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
        BTN[variant], className
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export function Field({ label, children, hint, required }) {
  return (
    <label className="block">
      {label && (
        <span className="mb-1.5 block text-[0.78rem] font-extrabold tracking-[0.015em] text-[#34463E]">
          {label}{required && <span className="text-rose-500"> *</span>}
        </span>
      )}
      {children}
      {hint && <span className="mt-1 block text-xs text-slate-400">{hint}</span>}
    </label>
  );
}

export const inputCls =
  "w-full min-h-11 rounded-xl border border-[#17211D]/15 bg-white/80 px-3.5 py-2.5 text-sm text-[#17211D] shadow-[0_1px_2px_rgba(23,33,29,0.05)] transition placeholder:text-slate-400 hover:border-[#2D7A65]/35 focus:border-[#2D7A65] focus:outline-none focus:ring-4 focus:ring-[#2D7A65]/10";
